module.exports = __webpack_public_path__ + "static/img/btn_fanxiao.be67848.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/btn_fanxiao.png
// module id = kLWS
// module chunks = 1